var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('coverage-form',{attrs:{"module":_vm.module,"editForm":true,"title":"Editar cobertura"},on:{"submit":_vm.saveModule}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }